// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.DeviceAttestationAndroid
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.crypto.X509CertChain

fun DeviceAttestationAndroid.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "q0ZiWqM2i7anBI3hnAJMbtYUOXTx9mTdrDvFUYMI-Vw")
val DeviceAttestationAndroid_cborSchemaId = ByteString(-85, 70, 98, 90, -93, 54, -117, -74, -89, 4, -115, -31, -100, 2, 76, 110, -42, 20, 57, 116, -15, -10, 100, -35, -84, 59, -59, 81, -125, 8, -7, 92)

fun DeviceAttestationAndroid.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Android")
    builder.put("certificateChain", this.certificateChain.toDataItem())
    return builder.end().build()
}

fun DeviceAttestationAndroid_fromDataItem(dataItem: DataItem): DeviceAttestationAndroid {
    val certificateChain = X509CertChain.fromDataItem(dataItem["certificateChain"])
    return DeviceAttestationAndroid(
        certificateChain = certificateChain,
    )
}
